export default __webpack_public_path__ + "static/media/enneperuhr_dark.30125010.png";